import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Component({
  selector: 'app-space-rocket',
  templateUrl: './space-rocket.component.html',
  styleUrls: ['./space-rocket.component.scss']
})
export class SpaceRocketComponent implements OnInit {
  allApplications: any[] = [];
  filtered: any[] = [];
  loading = true;

  // Filters
  filterStatus = 'All';
  filterDateFrom = '';
  filterDateTo = '';
  searchId = '';

  statuses = ['All', 'Submitted', 'Approved', 'Rejected', 'In Review'];

  expandedKey: string | null = null;

  constructor(private db: AngularFireDatabase) {}

  ngOnInit() {
    this.db.database.ref('/spacerocket').once('value', snapshot => {
      const val = snapshot.val();
      if (val) {
        this.allApplications = Object.keys(val).map(key => ({
          _key: key,
          ...val[key]
        })).sort((a, b) => (b.createdOn || 0) - (a.createdOn || 0));
      }
      this.loading = false;
      this.applyFilters();
    });
  }

  applyFilters() {
    let result = [...this.allApplications];

    if (this.filterStatus !== 'All') {
      result = result.filter(a => a.status === this.filterStatus);
    }

    if (this.filterDateFrom) {
      const from = new Date(this.filterDateFrom).getTime();
      result = result.filter(a => (a.createdOn || 0) >= from);
    }

    if (this.filterDateTo) {
      const to = new Date(this.filterDateTo).getTime() + 86400000; // inclusive end of day
      result = result.filter(a => (a.createdOn || 0) <= to);
    }

    if (this.searchId.trim()) {
      const q = this.searchId.trim().toLowerCase();
      result = result.filter(a => (a.applicationId || '').toLowerCase().includes(q));
    }

    this.filtered = result;
  }

  clearFilters() {
    this.filterStatus = 'All';
    this.filterDateFrom = '';
    this.filterDateTo = '';
    this.searchId = '';
    this.applyFilters();
  }

  toggle(key: string) {
    this.expandedKey = this.expandedKey === key ? null : key;
  }

  formatDate(ts: number): string {
    if (!ts) return '—';
    return new Date(ts).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  }

  formatOperationHour(h: number, m: number): string {
    const hh = h.toString().padStart(2, '0');
    const mm = m.toString().padStart(2, '0');
    return `${hh}:${mm}`;
  }

  dayLabel(day: string): string {
    return day.charAt(0).toUpperCase() + day.slice(1, 3);
  }

  operationDays(timings: any): { day: string; from: string; to: string; holiday: boolean }[] {
    if (!timings) return [];
    const order = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    return order.filter(d => timings[d]).map(d => ({
      day: this.dayLabel(d),
      from: this.formatOperationHour((timings[d].from || {}).hour || 0, (timings[d].from || {}).minute || 0),
      to: this.formatOperationHour((timings[d].to || {}).hour || 0, (timings[d].to || {}).minute || 0),
      holiday: timings[d].holiday === true
    }));
  }

  subSpaceList(subSpaceDetails: any): any[] {
    if (!subSpaceDetails) return [];
    return Object.values(subSpaceDetails);
  }

  amenityEntries(amenityDetails: any): { key: string; value: string }[] {
    if (!amenityDetails) return [];
    return Object.keys(amenityDetails).map(k => ({ key: k, value: amenityDetails[k] }));
  }
}
